__turbopack_context__.v({
  "button": "-DHMjW_button",
  "container": "-DHMjW_container",
  "description": "-DHMjW_description",
  "heading": "-DHMjW_heading",
  "icon": "-DHMjW_icon",
  "text": "-DHMjW_text",
});
